import useSound from 'use-sound';
import React from 'react';

import boopSfx from '../../assets/don-hang-trung.mp3';

const BoopButton = React.forwardRef((props, ref) => {
  const [play] = useSound(boopSfx);
  return <button ref={ref} {...props} onClick={play}></button>
});
export default BoopButton